import { ExperienceTemplate } from 'experience-template-renderer-react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { SortAndFiltersViewType } from '@shared-ui/retail-sort-and-filter-lodging';

export const splitViewTemplate: ExperienceTemplate = {
  id: 'split-view-large',
  version: '1',
  components: [
    {
      metadata: {
        id: 'LayoutFlex',
      },
      type: 'UitkComponent',
      config: {
        type: 'UitkLayoutFlex',
        direction: 'column',
      },
      children: [
        {
          metadata: {
            id: 'toolbarRegion',
          },
          type: 'ToolbarRegion',
          children: [
            {
              metadata: {
                id: 'playback',
              },
              type: 'Playback',
            },
          ],
        },
        {
          metadata: {
            id: 'resultsWrapper',
          },
          type: 'ResultsWrapper',
          config: {
            columns: 1,
            space: 'six',
          },
          children: [
            {
              metadata: {
                id: 'filterbarColumn',
              },
              type: 'UitkComponent',
              config: {
                type: 'UitkLayoutGridItem',
                colSpan: 1,
              },
              children: [
                {
                  metadata: {
                    id: 'filterbar',
                  },
                  type: 'Filterbar',
                  config: {
                    view: SortAndFiltersViewType.FILTER_BAR,
                  },
                },
              ],
            },
          ],
        },
        {
          metadata: {
            id: 'LayoutFlexMain',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlex',
          },
          children: [
            {
              metadata: {
                id: 'LayoutFlexItemMain',
              },
              type: 'UitkComponent',
              config: {
                type: 'UitkLayoutFlexItem',
                grow: 1,
              },
              children: [
                {
                  metadata: {
                    id: 'mainRegion',
                  },
                  type: 'MainRegion',
                  children: [
                    {
                      metadata: {
                        id: 'resultsWrapper',
                      },
                      type: 'ResultsWrapper',
                      config: {
                        columns: 6,
                        space: 'six',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'MapView',
                          },
                          type: 'MapView',
                          config: {
                            view: SortAndFiltersViewType.FILTER_BAR,
                          },
                        },
                        {
                          metadata: {
                            id: 'resultsColumn',
                          },
                          type: 'UitkComponent',
                          config: {
                            type: 'UitkLayoutGridItem',
                            colSpan: 4,
                          },
                          children: [
                            {
                              metadata: {
                                id: 'customerNotificationsAfterHeader',
                              },
                              type: 'CustomerNotificationTemplateComponent',
                              config: {
                                location: CustomerNotificationLocation.AFTER_HEADER,
                              },
                            },
                            {
                              metadata: {
                                id: 'search-results',
                              },
                              type: 'SearchResultsWrapper',
                            },
                          ],
                        },
                        {
                          metadata: {
                            id: 'mapViewColumn',
                          },
                          type: 'UitkComponent',
                          config: {
                            type: 'UitkLayoutGridItem',
                            colSpan: 1,
                          },
                          children: [
                            {
                              metadata: {
                                id: 'sideRailRegion',
                              },
                              type: 'SideRailRegion',
                              children: [
                                {
                                  metadata: {
                                    id: 'mesoSideRail',
                                  },
                                  type: 'MesoSideRail',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'customerNotificationsFooter',
                      },
                      type: 'CustomerNotificationTemplateComponent',
                      config: {
                        location: CustomerNotificationLocation.FOOTER,
                      },
                    },
                    {
                      metadata: {
                        id: 'loyaltyEducationDialog',
                      },
                      type: 'LoyaltyEducationDialog',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
